import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_CIRCLE_QUESTION_MARK: GlameraIconDefinition = {
  name: 'circle-question-mark',
  viewBox: '0 0 24 24',
  svg: `
    <circle class="glm-circle-question-mark-ring" cx="12" cy="12" r="10"></circle>
    <path class="glm-circle-question-mark-curl" d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
    <path class="glm-circle-question-mark-dot" d="M12 17h.01"></path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-circle-question-mark-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './circle-question-mark.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class CircleQuestionMarkIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_CIRCLE_QUESTION_MARK;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
